// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"7654fed1","42":"8012ecd5","173":"faebb016","412":"ec0d85ef","577":"ca96f2a1","776":"b2c31427","880":"6c31a49e","916":"eef32e9d","945":"7a669d4d"}[chunkId] + ".chunk.js";
};